import { useQuery } from 'react-query';

import { getRowTypeOptions as queryFn } from 'api/endPoints/getRowTypeOptions';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetRowTypeOptions = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getRowTypeOptions'],
        queryFn: () => queryFn(),
    });
};

export const ROW_TYPE_KEYS = {
    MILESTONE: 'MILESTONE',
    SUMMARY_BAR: 'SUMMARY_BAR',
} as const;

export type RowTypeKey = (typeof ROW_TYPE_KEYS)[keyof typeof ROW_TYPE_KEYS];

export interface QueryResponse {
    key: RowTypeKey;
    value: string;
}
